<template>
	<div class="app-locale-switcher">
		<!-- <ao-select
			:modelValue="$i18n.locale"
			:items="locales"
			itemTitle="title"
			itemValue="value"
			hide-details
			prependIcon="flags"
			variant="underlined"
			@update:modelValue="switchLocale($event)"
		/> -->
		<v-select
			:modelValue="$i18n.locale"
			:items="locales"
			itemTitle="title"
			itemValue="value"
			hide-details
			variant="underlined"
			@update:modelValue="switchLocale($event)"
		/>
	</div>
</template>

<script setup>
import { computed, inject } from 'vue'

// import { AoSelect } from '@ao/ui'

const i18nService = inject('i18nService')

const switchLocale = async (newLocale) => {
	if (i18nService) {
		await i18nService.setLocale(newLocale);
	}
}

const locales = computed(() => {
	return Object.keys(i18nService.supportedLocales).map((localeKey) => {
		return {
			value: localeKey,
			title: i18nService.supportedLocales[localeKey],
		}
	})
})
</script>
